/**
 * The **widget-based board view** (`specs/M10-D1-dashboards.md` §5) — the kind this account uses
 * instead of standalone dashboards: five board views that host widgets `[vui]`.
 *
 * It replaces the `dashboard` entry that lived in `views/placeholders/index.ts`. The view row
 * itself holds almost nothing: the configuration lives in the `widgets` rows, and every one of
 * the five production views returns `settings_str: "{}"` anyway `[raw]`. `settings` is therefore
 * a loose object so an imported `settings_str` survives a round trip untouched.
 */
import { z } from 'zod';
import { defineViewType } from '../types.js';
export const dashboardViewSettingsSchema = z.looseObject({
    /** Ordering hint only; the `widgets` rows are the store. */
    widgetIds: z.array(z.string()).optional(),
});
export const dashboardView = defineViewType({
    id: 'dashboard',
    title: 'Dashboard',
    mondayViewType: 'DashboardBoardView',
    kind: 'DASHBOARD',
    settingsSchema: dashboardViewSettingsSchema,
    defaultSettings: {},
    requiredColumnTypes: [],
    /** The toolbar has Person + Filter but no Sort and no Group by: a canvas is not an item list. */
    supportsFilters: true,
    supportsSort: false,
    supportsGroupBy: false,
    canBeDefault: false,
    implemented: true,
    plannedIn: null,
    gallery: { order: 10, section: 'board-views' },
});
//# sourceMappingURL=index.js.map